/* 此文件由 scripts/generate-iconfont.mjs 自动生成，请勿手工修改。 */
export const iconSpritePrefix = "Z-";
export const iconNames = [
  "qr-code-line",
  "attachment-2",
  "layout-5-line",
  "wenjian1",
  "shipin1",
  "tupian1",
  "excel",
  "pdf",
  "ppt",
  "txt",
  "word",
  "yuyin",
  "a-ailuyinzhuanxiesvg",
  "pause-mini-fill",
  "stop-fill",
  "play-large-fill",
  "sparkling-2-fill",
  "play-circle-line",
  "download-line",
  "question-line",
  "information-2-line",
  "dianhua2",
  "piyue",
  "xiugai1",
  "shoucangxuanzhong",
  "shoucang",
  "sip-fill",
  "xuanban1",
  "xuanke1",
  "dianziqianbao",
  "xuanwu",
  "d-arrow-right",
  "d-arrow-left",
  "arrow-right-up-line",
  "chucunka",
  "bubble",
  "quanbudaohang",
  "bangzhuzhongxin-hover",
  "bangzhuzhongxin",
  "aira",
  "tuichuxuanzhong1",
  "icon1",
  "icon-2",
  "icon",
  "icon-3",
  "icon-4",
  "icon-1",
  "shezhixuanzhong",
  "kuaijiefangshixuanzhong",
  "xiazaixuanzhong",
  "zaixianfankuixuanzhong",
  "yingyongxuanzhong",
  "shuqianxuanzhong1",
  "zaixiankefuxuanzhong",
  "shuqian1",
  "zaixianfankui1",
  "xiazai5",
  "tuichuxuanzhong2",
  "zaixiankefu",
  "kuaijiefangshi2",
  "shezhi2",
  "yingyong1",
  "jishuzhichishouquanma",
  "jishuzhichishouquanmaxuanzhong",
  "hide",
  "edit",
  "filter",
  "s-tools",
  "more-filled",
  "delete-filled",
  "setting",
  "view",
  "clock",
  "calendar",
  "select",
  "more",
  "remove-filled",
  "caret-bottom",
  "circle-check-filled",
  "check",
  "d-caret",
  "refresh-left",
  "warning-outline",
  "remove",
  "semi-select",
  "circle-check",
  "circle-plus-filled",
  "circle-close-filled",
  "close-bold",
  "circle-plus",
  "info-filled",
  "minus",
  "plus",
  "circle-close",
  "caret-right",
  "close",
  "search",
  "question-filled",
  "caret-left",
  "warning-filled",
  "caret-top",
  "time-line",
  "user-6-line",
  "loop-left-fill",
  "indent-increase",
  "indent-decrease",
  "gallery-view-2",
  "list-check",
  "a-arrow-down",
  "a-arrow-left-bold",
  "a-arrow-left",
  "a-arrow-right-bold",
  "a-arrow-right",
  "a-arrow-down-bold",
  "a-arrow-up",
  "a-arrow-up-bold",
  "reportcenter",
  "caiwugl",
  "jinxiaocun",
  "renshigl",
  "qiantaiyw",
  "shouqiangl",
  "jiaowugl",
  "shishengxin",
] as const;

export type IconName = (typeof iconNames)[number];
